<template>
  <div class="Words">
    <Word v-for="(w,k) in words" :key="w" :pos="pos[k]" :id="k" :txt="w" :color="colors[k]" :description="descriptions[k]"/>
  </div>
</template>
<script>
import Word from './Word'
import { Oeuvre_words } from '../js/Words.js'
import { Descriptions_words } from '../js/Descriptions.js'
export default {
  name: 'Words',
  components: { Word },
  data: () => ({ 
    words: {},
    colors: {
      0 : 'yellow',
      1 : 'blue',
      2 : 'blue',
      3 : 'green',
      4 : 'green',
      5 : 'yellow',
      6 : 'blue',
      7 : 'blue',
      8 : 'green',
      9 : 'yellow',
      10 : 'blue',
      11 : 'green',
    },
    pos: [
      [ -910, -20 ],
      [ -700, -100 ],
      [ -1050, 90 ],
      [ -1060, -125 ],
      [ -720, 120 ],
      [ -900, -250 ],
      [ 910, -20 ],
      [ 700, -100 ],
      [ 1050, 90 ],
      [ 1060, -125 ],
      [ 720, 120 ],
      [ 900, -250 ],   
    ],
  }),

  created() {
    this.words = Oeuvre_words[this.lang][this.oeuvre.name]
    this.descriptions = Descriptions_words[this.lang][this.oeuvre.name]
  },
  mounted(){
    this.$parent.words = this.words  
  },
  watch: {
    lang(nw, od) {
      this.words = Oeuvre_words[nw][this.oeuvre.name]
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Words
  position absolute 
  top 0 
  left 0

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Words.vue